import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { updatePages } from '../../redux/actions';

class ReorderPagesOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			pages: null
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		let { brochure } = this.props.state.brochure.payload;
		var pages = JSON.parse(JSON.stringify(brochure.pages));
		this.setState({
			pages: pages
		});
	}

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }

	moveItem(moveIndex, toIndex, event) {
		event.preventDefault();
		var pages = [],
			tempPages = this.state.pages;
		this.state.pages.map((item, index) => {
			var itm = JSON.parse(JSON.stringify(item));
			if(index === moveIndex) {
				itm = tempPages[toIndex];
			} else if(index === toIndex){
				itm = tempPages[moveIndex]
			}
			itm.sequence = index + 1;
			pages.push(itm);
			return null;
		});
		this.setState({
			pages: pages
		})
	}

	handleContinue(event) {
		event.preventDefault();
		this.props.dispatch(updatePages(this.state.pages));
		this.setState({
            showDialog: false
        });
	}

    render() {
		let { pages } = this.props.state.brochure.payload.brochure;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="reorderPagesOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Reorder Pages</h2>
                    <p>Use the up and down arrows to reorder pages.</p>
					<form className="smallReorderPagesForm" name="smallReorderPagesForm" id="smallReorderPagesForm" onSubmit={(e) => e.preventDefault()}>
			            <div className="pagesToReorder" style={{maxHeight: 250, overflowY: 'auto'}}>
							{this.state.pages && this.state.pages.map((item, index) => {
								return <div className="pageToReorder" key={index}>
				                	<div className="pageNumber">#{item.pageNumber}</div>
				                	<div className="pageName">{item.pageTitle}</div>
				                	<div className="pageReorderButtons">
										<a className={"movePageButton movePageUpButton " + (index===0?"hidden":"")} onClick={this.moveItem.bind(this, index, index-1)} href="">▲</a>
										<a className={"movePageButton movePageDownButton " + (index === pages.length - 1?"hidden":"")} onClick={this.moveItem.bind(this, index, index+1)} href="">▼</a>
				                	</div>
				              	</div>
							})}
			            </div>
						<div className="noButtonContainer">
	                        <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
	                    </div>
	                    <div className="yesButtonContainer">
	                        <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)}>Continue</a>
	                    </div>
		          	</form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ReorderPagesOverlayDialog = connect(mapStateToProps)(ReorderPagesOverlayDialog);
export default ReorderPagesOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/reorderPagesOverlayDialog.js